import { styled } from 'styled-components';

import type { IndicatorVariant } from '#/components/Indicator/types';
import { Text } from '#/components/Text/Text';
import { colors, fontSizes, spacing } from '#/theme/theme';

const variants = {
  default: {
    backgroundColor: colors.lightYellow,
    color: colors.mediumContentGrey,
  },
  warning: {
    backgroundColor: colors.lightRed,
    color: colors.alertRedHover,
  },
  info: {
    backgroundColor: colors.softBlue,
    color: colors.mediumContentGrey,
  },
  alternate: {
    backgroundColor: colors.lightPurple,
    color: colors.mediumContentGrey,
  },
};

export const SmallIndicatorBase = styled.div<{ $variant: IndicatorVariant }>`
  display: inline-flex;
  gap: ${spacing[6]};
  align-items: center;
  justify-content: center;
  background-color: ${({ $variant }) => variants[$variant].backgroundColor};
  color: ${({ $variant }) => variants[$variant].color};
  padding: ${spacing[6]} ${spacing[12]};
  border-radius: 8px;
  line-height: normal;
  font-size: ${fontSizes[16]};
`;

export const SmallIndicatorIconHolder = styled.div`
  align-self: start;
  translate: 0 -3.5%;
`;

export const LargeIndicatorBase = styled.div<{ $variant: IndicatorVariant }>`
  display: inline-flex;
  gap: ${spacing[16]};
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ $variant }) => variants[$variant].backgroundColor};
  color: ${({ $variant }) => variants[$variant].color};
  padding: ${spacing[12]} ${spacing[24]};
  border-radius: 8px;
  line-height: normal;
  font-size: ${fontSizes[16]};
`;

export const IndicatorHeadline = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  margin-block-end: 0.25em;
`;

export const IndicatorIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    width: 40px;
    height: 40px;
  }
`;
